const openBtn = document.getElementById('hunbugerOpen');
const closeBtn = document.getElementById('close');
const drawer = document.getElementById('drawer');
openBtn.addEventListener('click', () => {
  if (!drawer.classList.contains('open')) {
    drawer.classList.add('open');
  }
});
closeBtn.addEventListener('click', () => {
  drawer.style.opacity = 0;
  setTimeout(() => {
    drawer.classList.remove('open');
    drawer.style.opacity = 1;
  }, 400);
});

const pathes = {
  '/pages/news': 'NEWS',
  '/pages/store': 'STORE',
  '/pages/about-us': 'ABOUT US',
  '/pages/contact': 'CONTACT',
  '/pages/collection': 'COLLECTION',
};
const currentPath = window.location.pathname;
const navLinks = Array.from(document.querySelectorAll('.ey-header__nav__link--js'));
navLinks.forEach(el => {
  if (pathes[currentPath] === el.id) {
    el.classList.add('current');
  } else {
    el.classList.remove('current');
  }
});
